let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jAiVN")).then(() => parcelRequire('cHJgY'));